import type {ReactNode} from 'react';

import classnames from 'classnames';

import {MODE, type Mode} from './types';

import styles from './collapsed-message-input-row.module.css';

interface Props {
    previewText: string;
    placeholder?: string;
    onExpand: () => void;
    footer?: ReactNode;
    mode?: Mode;
}

export function CollapsedMessageInputRow(props: Props) {
    const trimmedMessage = props.previewText.trim();

    return (
        <div
            className={classnames(styles['collapsed-content-row'], {
                [styles['note-mode']]: props.mode === MODE.INTERNAL_NOTE,
            })}
            onClick={props.onExpand}
        >
            <div
                className={classnames(styles['collapsed-preview'], {
                    [styles['collapsed-preview-placeholder']]: !trimmedMessage,
                })}
            >
                {trimmedMessage || props.placeholder}
            </div>
            {props.footer != null && <div onClick={(e) => e.stopPropagation()}>{props.footer}</div>}
        </div>
    );
}
